import axios from 'axios'

import { File, OrderStates } from 'common/server/server_types'

export interface VendorCompanies {
  id: string
  default_watcher_vendor_user_ids: string[]
  company: {
    id: string
    name: string
    logo?: File
  }
}

export interface VendorCompany {
  id: string
  default_watcher_vendor_user_ids: string[]
  company: {
    id: string
    name: string
    logo?: File
  }
}

export interface UpdateVendorCompany {
  id: string
  default_watcher_vendor_user_ids: string[]
  apply_retroactively?: boolean // If true all previous orders will change with the news default watchers, else only new orders will apply to default watchers
}

export interface OrderStats {
  [comoanyId: string]: {
    [orderState: OrderStates]: number
  }
}

export function getVendorCompanies() {
  return axios.get<{ vendor_companies: VendorCompanies[] }>('/vendor/vendor_companies')
}

export function getVendorCompany(id: string) {
  return axios.get<{ vendor_company: VendorCompany }>(`/vendor/vendor_companies/${id}`)
}

export function updateVendorCompany({ id, ...vendor_company }: UpdateVendorCompany) {
  return axios.put(`/vendor/vendor_companies/${id}`, { vendor_company })
}

export function getOrderStatsByCustomers() {
  return axios.get<{ order_stats: OrderStats }>('/vendor/vendor_companies/order_stats')
}
